import {HistoryState} from '@PosterWhiteboard/poster/poster-history/history-state';
import type {FabricObject} from '@postermywall/fabricjs-2';

export class HistoryStateDrawing extends HistoryState {
  public drawnFabricObjects: Record<string, FabricObject[]>;

  public constructor(drawingFabricObjects: Record<string, FabricObject[]>) {
    super();
    this.drawnFabricObjects = drawingFabricObjects;
  }
}
